import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import 'swiper/css/bundle';

class relatedResourcesSlider extends Component {
  public relatedResources: {
    destroy?: () => void | undefined;
    updateSize?: () => void | undefined;
  };

  constructor(el: HTMLElement) {
    super(el);
    this.relatedResources = {};
  }

  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll<HTMLElement>('.swiper-slide'),
      pagination: this.el.querySelector<HTMLElement>(
        '.related-resources-slider__slider-pagination'
      ),
      prevButton: this.el.querySelector<HTMLElement>('.btn-previous-slide'),
      nextButton: this.el.querySelector<HTMLElement>('.btn-next-slide')
    };

    this.initSwiper();
  }

  addListeners() {
    window.addEventListener('resize', () => {
      this.initSwiper();
    });
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);

    if (
      this.relatedResources &&
      this.relatedResources.destroy &&
      typeof this.relatedResources.destroy === 'function'
    )
      this.relatedResources.destroy();

    this.relatedResources = new Swiper(this.dom.swiperContainer as HTMLElement, {
      pagination: {
        el: this.dom.pagination as HTMLElement,
        type: 'progressbar'
      },
      navigation: {
        nextEl: this.dom.nextButton as HTMLElement,
        prevEl: this.dom.prevButton as HTMLElement
      },
      slidesPerView: 1.22,
      spaceBetween: 24,
      autoHeight: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      },
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }
}

export default relatedResourcesSlider;
